import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorScreen from '../ErrorScreens';
import { isPublicRoute, isRouteAllowedForUser } from './access/urlAccessManager';

/**
 * Layout route element that gates its children behind the per-route rules in
 * access/urlAccessManager.js.
 *
 * This is a component (not a loader) because `sessionContextOidc.userView` is
 * fetched by <Header /> on mount and is not available while loaders run on a
 * hard refresh. Until the session has loaded we render nothing (the Header
 * shell is already on screen), so gated content never flashes.
 *
 * Denied (or session failed to load) -> the existing 403 screen.
 */
const UrlAccessGate = () => {
    const { pathname } = useLocation();
    const { userView, loaded, error } = useSelector((state) => state.sessionContextOidc || {});

    if (isPublicRoute(pathname)) return <Outlet />;

    if (!loaded && !error) return null;

    if (!error && isRouteAllowedForUser(pathname, userView?.permissions)) {
        return <Outlet />;
    }

    return <ErrorScreen status={403} />;
};

export default UrlAccessGate;
